import type { GridColumnInfo } from '../types'
import { formatDateDisplayText, isDateColumnType } from './date-cell'
import { formatSwitchDisplayText } from './switch-cell'

export function setCellFieldValue(
  row: Record<string, unknown>,
  field: string,
  value: unknown
) {
  row[field] = value
}

export function getCellValue(
  row: Record<string, unknown>,
  column: GridColumnInfo
) {
  if (!column.field) {
    return undefined
  }
  const value = row[column.field]
  if (column.type === 'switch') {
    return formatSwitchDisplayText(value)
  }
  if (isDateColumnType(column.type)) {
    return formatDateDisplayText(value, column.type)
  }
  return value
}
